<template>
    <div>
        <h3> サーベイ情報 </h3>

        <table>
            <tr v-for="(item, i) in items" :key="i">
                <td>{{item.label}}</td>
                <td>{{item.value}}</td>
            </tr>
        </table>

    </div>
</template>
<script>
export default {
    components: {},
    props: {
    },
    data() {
        return {
            items: [
                { label: "名前", value: "渡辺　大輔" },
                { label: "評価者数", value: "５人" },
                { label: "サーベイ期間", value: "2018/9/24 - 2018/9/28" },
            ]
        }

    },

}
</script>

<style lang="scss" scoped>
table {
  border-collapse: collapse;
  border: 1px solid rgba(0, 0, 0, 0.12);
  width: 300pt;
  tr, td, th {
    border-collapse: collapse;
    border: 1px solid rgba(0, 0, 0, 0.12);
  }
  td{
      padding: 5pt;
  }
}
</style>